import { FelaCSS, colors } from '@bridebook/ui';
import { ISharedTypes as IStyleProps } from './info-block';

interface IStyles {
  wrapper: FelaCSS;
  iconWrap: FelaCSS;
  textWrap: FelaCSS;
}

const styles = ({ large, disabled }: IStyleProps): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    flexShrink: 0,
    alignItems: 'center',

    maxWidthTabletSm: {
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: '5px',
      paddingRight: '5px',
      width: '100%',
      height: '100%',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: colors.space15,
      borderRadius: '4px',
      textAlign: 'center',
      backgroundColor: disabled ? colors.space04 : 'transparent',
    },

    superSmallMobile: large
      ? {
          flexDirection: 'row',
        }
      : {},
  },

  iconWrap: {
    marginRight: '8px',

    maxWidthTabletSm: {
      marginRight: '0',
      marginBottom: '8px',
    },

    superSmallMobile: large
      ? {
          marginRight: '16px',
          marginBottom: '0',
        }
      : {},
  },

  textWrap: {
    flexShrink: 0,
    fontDefault: 14,
    lineHeight: '16px',
    color: disabled ? colors.space15 : colors.space,
    textDecoration: 'none',

    maxWidthTabletSm: {
      fontDefault: 12,
      lineHeight: '14px',
      textDecoration: 'none',
    },

    superSmallMobile: large
      ? {
          width: '50%',
          textAlign: 'left',
        }
      : {},
  },
});

export default styles;
